<!--
  @file Componente InputBuscar.vue
  @description Componente para busqueda de items por filtro
  
  @author Adrian Zayas <adrianzayas@unindetec.edu.mx>
  @date 05-02-2025
  @version 2.0.0
-->
<template>
  <component :is="wrapperTag" class="search-filter">
    <b-col v-if="isRowLayout" cols="12" md="5" lg="6" xl="6">
      <b-form-input
        id="filter-input"
        v-model="localFilter"
        type="search"
        :placeholder="$t('Gral.buscar')"
        :class="{ 'mb-2': isColumnLayout }">
      </b-form-input>
    </b-col>

    <b-col v-if="isRowLayout" cols="12" sm="12" md="3" lg="3" xl="3">
      <b-button
        class="text-white boton-limpiar"
        variant="info"
        :disabled="!localFilter"
        @click="clearFilter"
        :class="{ 'w-100': isColumnLayout }"
        :style="{ color: 'white' }">
        {{ $t("Gral.limpiarBusqueda") }}
      </b-button>
    </b-col>

    <template v-if="isColumnLayout">
      <b-form-input
        id="filter-input2"
        v-model="localFilter"
        type="search"
        :placeholder="$t('Gral.buscar')"
        class="mb-2">
      </b-form-input>

      <b-button
        class="boton-limpiar"
        variant="info"
        :disabled="!localFilter"
        @click="clearFilter"
        :style="{ color: 'white' }">
        {{ $t("Gral.limpiarBusqueda") }}
      </b-button>
    </template>
    <slot></slot>
  </component>
</template>

<script>
export default {
  /**
   * Props para el componente InputBuscar.
   * 
   * @property {String} filter - Valor utilizado para filtrar la busqueda.
   * @property {Object} layout - Define el diseño del componente.
   * @property {String} layout.type - Tipo de diseño, 'row' o 'column'.
   * @property {String} layout.default - Establece el tipo de diseño a 'row' por defecto.
   * @property {Function} layout.validator - Función para validar el tipo de layout.
   */
  props: {
    filter: String,
    layout: {
      type: String,
      default: "row",
      validator: (value) => ["row", "column"].includes(value),
    },
  },
  emits: ["input"],
  data() {
    return {
      /** Variable encargada de almacenar el prop 'filter', en caso de no almacenar un valor se establece a vacio. */
      localFilter: this.filter || "",
    };
  },
  computed: {
    isRowLayout() {
      return this.layout === "row";
    },
    isColumnLayout() {
      return this.layout === "column";
    },
    wrapperTag() {
      return this.isRowLayout ? "b-row" : "div";
    },
  },
  watch: {
    localFilter(newVal) {
      this.$emit('input', newVal);
    },
    filter(newVal) {
      this.localFilter = newVal;
    },
  },
  methods: {
    clearFilter() {
      this.localFilter = "";
    },
  },
};
</script>

<style>
  .boton-limpiar{
    width: 100%;
  }
  @media (max-width: 960px) {
    .boton-limpiar{
      width: 100%;
      margin-bottom: 0.1rem;
    }
    #filter-input, #filter-input2{
      margin-bottom: -0.8rem;
    }
  }
</style>